import Stack from "@mui/system/Stack"
import Link from "next/link"
import CloseIcon from '@mui/icons-material/Close';
import dynamic from "next/dynamic";
import { FindBadgeProps } from "./FindDesignTypes";
import { useLayoutData } from "../../../utils/contexts/LayoutContext";
import { useMemo } from "react";
import { useRouter } from "next/router";
import { PageType } from "../../../pages/_app";
import { FindFilterBadgeProps } from "./Find.types";

const FindFilterBadge = ({
  title,
  resetUrl,
  pageUrl,
  colors
}: FindFilterBadgeProps) => {
  const router = useRouter()
  const { mmbr } = router.query

  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindBadge = useMemo(() => dynamic<FindBadgeProps>(() => import(`../../../design/${path}/_findDesign/Design`).then((style) => style.FindBadge)), [path])

  return (
    <>
      {resetUrl ? (
        <Link href={(pageUrl ? "/" + pageUrl : '') + (resetUrl ? resetUrl : '') + (mmbr ? resetUrl == '/' || resetUrl.slice(-1) !== '/' ? resetUrl.includes('?') ? `&mmbr=${mmbr}` : `?mmbr=${mmbr}` : `&mmbr=${mmbr}` : '') } scroll={false}>
          <a>
            <FindBadge bgcolor={colors.mainColor} bghovercolor={colors.secondaryColor}>
              <Stack mr={0.5}>{title}</Stack>
              <Stack><CloseIcon /></Stack>
            </FindBadge>
          </a>
        </Link>
      ) : (
        <FindBadge bgcolor={colors.mainColor} bghovercolor={colors.secondaryColor}>
          <Stack mr={0.5}>{title}</Stack>
        </FindBadge>
      )}
    </>
  )
}

export default FindFilterBadge